import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { ChangeEvent, useEffect, useState, Dispatch } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useSession, xapi } from '../../hooks/session';
import SwLoading from './spinner/SwLoading';
import mapPinIcon from '../../images/sub/map_pin.svg';
import openBookIcon from '../../images/sub/open_book.svg';
import walkingManIcon from '../../images/sub/waking_man.svg';
import {
  KEY_READ_TEXT,
  KEY_USER_READ_LIST,
  KEY_USER_STEP_LIST,
  KEY_USER_WRITE_LIST,
  KEY_USER_WRITE_STAT_LIST,
  KEY_WALK_TEXT,
} from '../../common/key';

import {
  convert2Date,
  encodeSearchWord,
  firstDayOfMonth,
  formatDateString,
  lastDayOfMonth,
} from '../../common/helper';
import {
  getUserReadList,
  getUserStepList,
  getUserWriteList,
  getUserWriteStatList,
} from '../../common/api/ApiUser';
import { SwSelectMonth } from './SwSelectMonth';
import NoDataPage from './NoDataPage';
import { EmptyPage } from './EmptyPage';
import { SwPagination } from './tableElement/SwPagination';

const columns = ['도서 제목', '출판사', '저자', '완독날짜'];
const stepColumns = ['날짜', '걸음수', '금/은/동'];
const writeColumns = ['날짜', '글개수', '금/은/동'];
const DEFAULT_WIDTH = '4rem';

interface Props {
  title: string;
  memberSeq: number;
  targetMonth: any;
  medalInfo: any;
  open: boolean;
  onClose: () => void;
}

export const SwUserRankDetail: React.FC<Props> = ({
  title,
  memberSeq,
  targetMonth,
  medalInfo,
  open,
  onClose,
}) => {
  const { loginVal } = useSession();
  const queryClient = useQueryClient();
  const [requestList, setRequestList] = useState<any>([]);
  const [bookSeq, setBookSeq] = useState<number>(-1);
  const [tabValue, setTabValue] = useState<number>(0);
  const [readType, setReadType] = useState<string>('history');
  const [writeItem, setWriteItem] = useState<string>('0');
  const [loading, setLoading] = useState<any>(false);
  const [searchKey, setSearchKey] = useState<string>('read');
  const [searchWord, setSearchWord] = useState<string>('');
  const rowsPerPageOptions = [5, 10, 15, 20];
  const [writePage, setWritePage] = useState(1);
  const [stepPage, setStepPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [stepRowsPerPage, setStepRowsPerPage] = useState(10);
  const [writeRowsPerPage, setWriteRowsPerPage] = useState(10);
  const [description, setDescription] = useState<string>(
    '텍스트가 이곳에 나옵니다. 텍스트가 이곳에 나옵니다. 텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.텍스트가 이곳에 나옵니다.나옵니다.텍스트가 이곳에 나옵니다.나옵니다.텍스트가 이곳에 나옵니다.나옵니다.텍스트가 이곳에 나옵'
  );

  const {
    data,
    isLoading,
    refetch: refetchUserRead,
  } = useQuery(
    KEY_USER_READ_LIST,
    () => {
      if (open) {
        const newData: any = {
          type: 'monthly-stat',
          seq: memberSeq,
          page: 0,
          rowsPerPage: 0,
          searchKey: searchKey,
          searchWord: encodeSearchWord(searchKey, searchWord),
          startDate: firstDayOfMonth(targetMonth * 1000).getTime(),
          endDate: lastDayOfMonth(targetMonth * 1000).getTime(),
        };
        return getUserReadList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        setLoading(false);
        if (res !== null) {
          setRequestList(res.readList);
        } else {
          setRequestList([]);
        }
      },
      onError: e => {
        setLoading(false);
        console.log(e);
      },
    }
  );

  const { refetch: refetchUserStep } = useQuery(
    KEY_USER_STEP_LIST,
    () => {
      if (open) {
        const newData: any = {
          seq: memberSeq,
          page: stepPage,
          rowsPerPage: stepRowsPerPage,
          searchKey: searchKey,
          searchWord: encodeSearchWord(searchKey, searchWord),
          startDate: firstDayOfMonth(targetMonth * 1000).getTime(),
          endDate: lastDayOfMonth(targetMonth * 1000).getTime(),
        };
        return getUserStepList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        setLoading(false);
        if (res !== null) {
          setRequestList(res.stepList);
          setTotalRecords(res.totalRecordCount);
        } else {
          setRequestList([]);
        }
      },
      onError: e => {
        setLoading(false);
        console.log(e);
      },
    }
  );

  const prefetchUserWalkState = (newPage: number) => {
    queryClient.prefetchQuery(KEY_USER_STEP_LIST, () => {
      const newData: any = {
        seq: memberSeq,
        page: newPage,
        rowsPerPage: stepRowsPerPage,
        searchKey: searchKey,
        searchWord: encodeSearchWord(searchKey, searchWord),
        startDate: firstDayOfMonth(targetMonth * 1000).getTime(),
        endDate: lastDayOfMonth(targetMonth * 1000).getTime(),
      };
      return getUserStepList(newData);
    });
  };

  const { refetch: refetchUserWriteState } = useQuery(
    KEY_USER_WRITE_STAT_LIST,
    () => {
      if (open) {
        const newData: any = {
          seq: memberSeq,
          page: writePage,
          rowsPerPage: writeRowsPerPage,
          searchKey: searchKey,
          searchWord: encodeSearchWord(searchKey, searchWord),
          startDate: firstDayOfMonth(targetMonth * 1000).getTime(),
          endDate: lastDayOfMonth(targetMonth * 1000).getTime(),
        };
        return getUserWriteStatList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        setLoading(false);
        if (res !== null) {
          setRequestList(res.writeList);
          setTotalRecords(res.totalRecordCount);
        } else {
          setRequestList([]);
        }
      },
      onError: e => {
        setLoading(false);
        console.log(e);
      },
    }
  );

  const prefetchUserWriteState = (newPage: number) => {
    queryClient.prefetchQuery(KEY_USER_WRITE_STAT_LIST, () => {
      const newData: any = {
        seq: memberSeq,
        page: newPage,
        rowsPerPage: writeRowsPerPage,
        searchKey: searchKey,
        searchWord: encodeSearchWord(searchKey, searchWord),
        startDate: firstDayOfMonth(targetMonth * 1000).getTime(),
        endDate: lastDayOfMonth(targetMonth * 1000).getTime(),
      };
      return getUserWriteStatList(newData);
    });
  };

  const downloadBookGroupList = (param: any) =>
    xapi
      .get(
        `/admin/v1/apis/book/download/book-group?searchKey=${param.searchKey}&searchWord=${param.searchWord}&startDate=${param.startDate}&endDate=${param.endDate}`,
        { responseType: 'blob' }
      )
      .then(res => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `book_group.xlsx`;
        document.body.appendChild(a);
        a.click();
        setTimeout((_: any) => {
          window.URL.revokeObjectURL(url);
        }, 600000);
        a.remove();
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.error('err: ', err);
      });

  const downloadItem = () => {
    const newData = {
      searchKey: 'book-group',
      searchWord: '',
      startDate: 0,
      endDate: 0,
    };
    setLoading(true);
    downloadBookGroupList(newData);
  };

  const clickReadType = (newReadType: string) => {
    setReadType(newReadType);
    const newDatas = requestList.filter(
      (row: any) =>
        row.type === newReadType || `${row.type}${row.status}` === newReadType
    );
    setTotalRecords(newDatas.length);
  };

  const handleChangeStepPage = (_event: any, newPage: number) => {
    setStepPage(newPage);
    prefetchUserWalkState(newPage);
  };

  const handleChangeWritePage = (_event: any, newPage: number) => {
    setWritePage(newPage);
    prefetchUserWriteState(newPage);
  };

  function getMedal(newStep: number) {
    return newStep >= medalInfo.goldLevel
      ? '금'
      : medalInfo.silverLevel > 0 && newStep >= medalInfo.silverLevel
      ? '은'
      : medalInfo.bronzeLevel > 0 && newStep >= medalInfo.bronzeLevel
      ? '동'
      : '-';
  }

  useEffect(() => {
    if (open) {
      title === KEY_READ_TEXT
        ? refetchUserRead()
        : title === KEY_WALK_TEXT
        ? refetchUserStep()
        : refetchUserWriteState();
    } else {
      setStepPage(1);
      setWritePage(1);
      setTabValue(0);
      setReadType('history');
      setRequestList([]);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          minHeight: '52vh',
          minWidth: '44vw',
        },
      }}
    >
      <DialogTitle>
        <Box
          className='flex_between'
          sx={{ mb: '1rem', borderBottom: 1, borderColor: 'divider' }}
        >
          <Box>
            <Typography className='title'>
              {`${title} 랭킹 상세보기`}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {title === KEY_READ_TEXT ? (
          <TableContainer sx={{ height: '50vh', overflowY: 'scroll' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {columns.map((column: any, idx: number) => (
                    <TableCell key={idx.toString()} sx={{ p: '.4rem .7rem' }}>
                      {column}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {requestList &&
                  requestList.length > 0 &&
                  requestList
                    .filter((row: any) => row.status === 'F')
                    .map((row: any) => [
                      row.title,
                      row.publisher,
                      row.author,
                      formatDateString(row.readFinishDt, '/'),
                    ])
                    .map((row: any, idx: number) => (
                      <TableRow key={`book_row_key_${idx}`}>
                        {columns.map((item: any, index: number) => (
                          <TableCell
                            key={`book_col_key+${index}`}
                            sx={{ p: '.7rem' }}
                          >
                            {row[index]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : title === KEY_WALK_TEXT ? (
          <>
            <TableContainer sx={{ height: '50vh', overflowY: 'scroll' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {stepColumns.map((column: any, idx: number) => (
                      <TableCell key={idx.toString()} sx={{ p: '.4rem .7rem' }}>
                        {column}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {requestList &&
                    requestList.length > 0 &&
                    requestList
                      .map((row: any) => [
                        row.day,
                        row.step,
                        getMedal(row.step),
                      ])
                      .map((row: any, idx: number) => (
                        <TableRow key={`book_row_key_${idx}`}>
                          {stepColumns.map((item: any, index: number) => (
                            <TableCell
                              key={`book_col_key+${index}`}
                              sx={{ p: '.7rem' }}
                            >
                              {row[index]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
            <SwPagination
              page={stepPage}
              handleChangePage={handleChangeStepPage}
              count={Math.ceil(totalRecords / stepRowsPerPage)}
            />
          </>
        ) : (
          <>
            <TableContainer sx={{ height: '50vh', overflowY: 'scroll' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {writeColumns.map((column: any, idx: number) => (
                      <TableCell key={idx.toString()} sx={{ p: '.4rem .7rem' }}>
                        {column}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {requestList &&
                    requestList.length > 0 &&
                    requestList
                      .map((row: any) => [
                        formatDateString(row.writeDate, '/'),
                        row.writeCount,
                        getMedal(row.writeCount),
                      ])
                      .map((row: any, idx: number) => (
                        <TableRow key={`book_row_key_${idx}`}>
                          {stepColumns.map((item: any, index: number) => (
                            <TableCell
                              key={`book_col_key+${index}`}
                              sx={{ p: '.7rem' }}
                            >
                              {row[index]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
            <SwPagination
              page={writePage}
              handleChangePage={handleChangeWritePage}
              count={Math.ceil(totalRecords / writeRowsPerPage)}
            />
          </>
        )}
      </DialogContent>
      {loading && <SwLoading />}
    </Dialog>
  );
};
